/* global rp$, window, document */

import './promotional_banner.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	require('core-js/fn/array/for-each');

	(function promotionalBannerModule(){
		$onReady({
			rp$, window,
			label: 'promotional_banner',
			fn: function () {
				var $promotional_banners = rp$('.promotional-banner-wrap');

				rp$.each($promotional_banners, function promotionalBanner_Iterator(idx, promo_ban_ele){

					var $banner_wrap = rp$(promo_ban_ele);
					var banner_max_height = 38;

					// Add ellipsis if text is wrapping
					var checkHeight = function(restrictToMax) {
						var banner_height = 0;
						if(restrictToMax === undefined) {
							restrictToMax = true;
						}

						$banner_wrap.removeClass('text-wrapping');
						$banner_wrap.removeClass('promo-expand');

						if($banner_wrap.is(':visible')) {
							banner_height = $banner_wrap.outerHeight();
						}

						if (restrictToMax && banner_height > banner_max_height) {
							$banner_wrap.addClass('text-wrapping');  // Wrap the text so that it only takes up one line
						}
					};

					//rp$(window).on('resize', debounce(checkHeight, 50));

					// Expand Function
					$banner_wrap.on('click', function promoExpandText() {
						if ($banner_wrap.is('.text-wrapping')) {
							if (!$banner_wrap.is('.promo-expand')) {
								$banner_wrap.addClass('promo-expand');
								checkHeight(false);
							}
							else if ($banner_wrap.is('.promo-expand')) {
								$banner_wrap.removeClass('promo-expand');
								checkHeight();
							}
						}
					});

					checkHeight();
				});
			},
		});

	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
